<style scoped lang="stylus">
    @import '../../../assets/css/theme.styl'
    .count-filter {
        .van-popup--right {
            width 100%
            height: 100vh
            box-sizing border-box
            padding 20px 10px
        }
        .van-popup {
            background-color: baseBackColor
        }
    }
</style>

<template>
    <div class="count-filter">
        <van-popup v-model="popShow" position="right">
            <van-field
                    readonly
                    clickable
                    clearable
                    label="厂区"
                    :value="factoryName"
                    placeholder="厂区"
                    @click="facPicker = true"
                    v-show="!isFactory"
            />
            <van-field
                    readonly
                    clickable
                    clearable
                    label="开始时间"
                    :value="startTime"
                    placeholder="开始时间"
                    @click="startTimePicker = true"
            />
            <van-field
                    readonly
                    clickable
                    clearable
                    label="结束时间"
                    :value="endTime"
                    placeholder="结束时间"
                    @click="endTimePicker = true"
            />


            <div class="bt-cus-box">
                <van-button type="primary" size="large" @click="searchSubmit">确 定</van-button>
                <van-button type="warning" size="large" @click="resetSearch">重 置</van-button>
                <van-button type="default" size="large" @click="hide">取 消</van-button>
            </div>
        </van-popup>

        <van-popup v-model="facPicker" position="bottom">
            <van-picker
                    show-toolbar
                    title="选择厂区"
                    :columns="facColumns"
                    @cancel="hideFac"
                    @confirm="facConfirm"
            />
        </van-popup>
        <van-popup v-model="startTimePicker" position="bottom">
            <van-datetime-picker
                    v-model="startTimeDate"
                    type="datetime"
                    :max-date="maxDate"
                    @confirm="startTimeConfirm"
                    @cancel="hideStartTime"
            />
        </van-popup>

        <van-popup v-model="endTimePicker" position="bottom">
            <van-datetime-picker
                    v-model="endTimeDate"
                    type="datetime"
                    :max-date="maxDate"
                    @confirm="endTimeConfirm"
                    @cancel="hideEndTime"
            />
        </van-popup>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import { getListNp } from "@/service/fac";

    export default {
        props: [
            'isFactory'
        ],
        components: {},
        data() {
            return {
                popShow: false,

                facPicker: false,
                factoryName: '',
                facColumns: [],
                facList: [],

                searchForm: {
                    factory_id: '',
                    settlement_time: '',
                },

                startTimePicker: false,
                endTimePicker: false,
                maxDate: dayjs().endOf('day').toDate(),
                startTimeDate: dayjs().toDate(),
                endTimeDate: dayjs().toDate(),
                startTime: '',
                endTime: '',
            };
        },
        created() {
            this.getFacList()
        },
        mounted() {

        },
        computed: {},
        watch: {},
        methods: {
            searchSubmit() {
                if (this.startTime != '' || this.endTime != '') {
                    if (this.startTime == '') {
                        this.$toast('开始时间不能为空')
                        return
                    }
                    if (this.endTime == '') {
                        this.$toast('结束时间不能为空')
                        return
                    }
                    if (dayjs(this.startTimeDate).isAfter(dayjs(this.endTimeDate))) {
                        this.$toast('开始结束时间不正确')
                        this.searchForm.settlement_time = ''
                        return
                    }
                    this.searchForm.settlement_time = `${this.startTime} - ${this.endTime}`
                } else {
                    this.searchForm.settlement_time = ''
                }

                // this.search()
                this.$emit('filter-change', this.searchForm)
                this.hide()
            },
            resetSearch() {
                this.resetTime()
                this.searchForm.factory_id = ''
                this.factoryName = ''
            },
            resetTime() {
                this.searchForm.settlement_time = ''
                this.startTime = ''
                this.endTime = ''
            },

            async getFacList() {
                let res = await getListNp()
                if (res.status) {
                    this.facList = res.data
                    this.facColumns = this.facList.map(item => {
                        return item.factory_name
                    })
                }
            },

            show(quickType) {
                if (quickType) {
                    this.startTime = ''
                    this.endTime = ''
                }
                this.popShow = true
            },
            hide() {
                this.popShow = false
            },

            hideFac() {
                this.facPicker = false
            },
            facConfirm(val, index) {
                this.factoryName = val
                this.searchForm.factory_id = this.facList[index].id
                this.hideFac()
            },

            startTimeConfirm(val) {
                this.startTime = dayjs(val).format('YYYY-MM-DD HH:mm')
                this.hideStartTime()
            },
            hideStartTime() {
                this.startTimePicker = false
            },
            hideEndTime() {
                this.endTimePicker = false
            },
            endTimeConfirm(val) {
                this.endTime = dayjs(val).format('YYYY-MM-DD HH:mm')
                this.hideEndTime()
            },
        },
    };
</script>
